export default __webpack_public_path__ + "static/media/nana.99382f01.png";